import React, { useState, useEffect } from "react";
import { Input, Button as AntButton } from "antd";
import { FilterFilled, CloseSquareFilled } from "@ant-design/icons";
import { RiFilterOffFill } from "react-icons/ri";
import { commonStrings } from "./StringBundle";
import { useGlobalStyles } from "./globalStyles";

function FilterPopup({ label, activeValue = "", onApply, onRemove, onClose, inputRef }) {
  const globalClasses = useGlobalStyles();
  const [inputValue, setInputValue] = useState(activeValue || "");

  // Sync input when the active value changes externally (e.g. chip removed)
  useEffect(() => {
    setInputValue(activeValue || "");
  }, [activeValue]);

  const handleApply = () => {
    if (!inputValue.trim()) return;
    onApply(inputValue.trim());
  };

  const handleRemove = () => {
    setInputValue("");
    onRemove();
  };

  return (
    <div onKeyDown={(e) => e.stopPropagation()} className={globalClasses.filterPopupRoot}>
      <Input
        ref={inputRef}
        autoFocus={!inputRef}
        placeholder={`${commonStrings.search} ${label}`}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onPressEnter={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleApply();
        }}
        className={globalClasses.filterInput}
        style={{ width: "100%", marginBottom: 8, height: 32, fontSize: 12 }}
      />
      <div className={globalClasses.filterActionsRow}>
        <AntButton
          type="link"
          size="small"
          disabled={!inputValue.trim()}
          onClick={handleApply}
          icon={<FilterFilled />}
          className={globalClasses.filterActionBtn}
        >
          {commonStrings.filter}
        </AntButton>
        <AntButton
          size="small"
          type="link"
          onClick={handleRemove}
          icon={<RiFilterOffFill />}
          className={globalClasses.filterActionBtn}
        >
          {commonStrings.remove}
        </AntButton>
        <AntButton
          type="link"
          size="small"
          onClick={onClose}
          icon={<CloseSquareFilled />}
          className={globalClasses.filterActionBtn}
        >
          {commonStrings.close}
        </AntButton>
      </div>
    </div>
  );
}

export default FilterPopup;
